import React from 'react';
import {Link} from 'react-router-dom';
import Tournaments from '../Widgets/Tournaments/Creations';
import TournamentsByStatus from '../Widgets/Tournaments/Statuses';
import TournamentsActiveUsers from '../Widgets/Tournaments/Users';
import TournamentsAverageSize from '../Widgets/Tournaments/AverageSize';
import TournamentsByUsers from '../Widgets/Tournaments/ByUser';
import TournamentsSizes from '../Widgets/Tournaments/Sizes';

export default () => (
  <div id="statistics-tournament">
    <header className="content-header">
      <h1>
        Statistics
        <small>Tournament</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-bar-chart" /> Statistics
        </li>
        <li className="text-bold">
          <Link to="/statistics/tournament">Tournament</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-lg-6">
          <Tournaments />
          <TournamentsByStatus />
          <TournamentsByUsers />
        </div>
        <div className="col-lg-6">
          <TournamentsActiveUsers />
          <TournamentsAverageSize />
          <TournamentsSizes />
        </div>
      </div>
    </section>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Tournaments/index.js